// Charte DOCC : bleu marine du logo, gris béton, ambre de signalisation pour l'élément actif.
import { createTheme } from '@mui/material/styles';

export const tokens = {
  navy: '#12284C',
  navyDeep: '#0C1B34',
  navySoft: '#1E3A66',
  concrete: '#ECEEF1',
  surface: '#FFFFFF',
  line: '#D9DDE3',
  lineSoft: '#E8EBEF',
  ink: '#142033',
  steel: '#5B6675',
  amber: '#E8A317',
  mono: '"IBM Plex Mono", ui-monospace, "Cascadia Mono", Consolas, monospace',
  sans: '"IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif',
};

const theme = createTheme({
  palette: {
    primary: { main: tokens.navy, dark: tokens.navyDeep, light: '#3A5683', contrastText: '#fff' },
    secondary: { main: tokens.amber, contrastText: tokens.ink },
    success: { main: '#1B7A46' },
    warning: { main: '#B7791F' },
    error: { main: '#B4232A' },
    info: { main: '#2C6BA0' },
    background: { default: tokens.concrete, paper: tokens.surface },
    text: { primary: tokens.ink, secondary: tokens.steel },
    divider: tokens.line,
  },
  shape: { borderRadius: 8 },
  typography: {
    fontFamily: tokens.sans,
    h4: { fontSize: '1.5rem', fontWeight: 600, letterSpacing: '-0.01em', lineHeight: 1.25 },
    h5: { fontSize: '1.25rem', fontWeight: 600, letterSpacing: '-0.005em' },
    h6: { fontSize: '1.05rem', fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 600 },
    button: { textTransform: 'none', fontWeight: 600, letterSpacing: 0 },
    // Étiquettes de section : en casse normale, discrètes
    overline: { textTransform: 'none', fontSize: '0.8rem', fontWeight: 600, letterSpacing: 0, lineHeight: 2, color: tokens.steel },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: tokens.concrete },
        '*:focus-visible': { outline: `2px solid ${tokens.amber}`, outlineOffset: 2 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
        elevation1: { boxShadow: 'none', border: `1px solid ${tokens.line}` },
        elevation2: { boxShadow: 'none', border: `1px solid ${tokens.line}` },
        elevation3: { boxShadow: 'none', border: `1px solid ${tokens.line}` },
        outlined: { borderColor: tokens.line },
      },
    },
    MuiCard: { defaultProps: { variant: 'outlined' } },
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { borderRadius: 8, paddingInline: 14 }, outlined: { borderColor: tokens.line } },
    },
    MuiIconButton: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiChip: { styleOverrides: { root: { borderRadius: 6, fontWeight: 500 } } },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: tokens.lineSoft },
        head: { backgroundColor: '#F4F6F8', color: tokens.steel, fontWeight: 600, fontSize: '0.8rem', whiteSpace: 'nowrap' },
      },
    },
    MuiTableRow: { styleOverrides: { root: { '&.MuiTableRow-hover:hover': { backgroundColor: '#F7F8FA' } } } },
    MuiAlert: { styleOverrides: { root: { borderRadius: 8 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 12 } } },
    MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: tokens.navyDeep, fontSize: '0.78rem' } } },
    MuiOutlinedInput: { styleOverrides: { notchedOutline: { borderColor: tokens.line } } },
  },
});

export default theme;
